import React from "react";
import { Box } from "@mui/material";

interface SimpleLayoutProps {
  children: React.ReactNode;
}

/**
 * A simple layout without a sidebar, used for full-page content like the PDF viewer
 */
const SimpleLayout: React.FC<SimpleLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          minHeight: "100vh",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SimpleLayout;
